export const STUDY_LEVELS = {
  'MBO Niveau 1': { color: 'from-blue-500 to-cyan-500', icon: '🎓' },
  'MBO Niveau 2': { color: 'from-blue-600 to-cyan-600', icon: '🎓' },
  'MBO Niveau 3': { color: 'from-blue-700 to-cyan-700', icon: '🎓' },
  'MBO Niveau 4': { color: 'from-blue-800 to-cyan-800', icon: '🎓' },
  'HBO Associate Degree': { color: 'from-purple-500 to-pink-500', icon: '🎓' },
  'HBO Bachelor': { color: 'from-purple-600 to-pink-600', icon: '🎓' },
  'HBO Master': { color: 'from-purple-700 to-pink-700', icon: '🎓' },
  'Universiteit Bachelor': { color: 'from-indigo-500 to-purple-500', icon: '🎓' },
  'Universiteit Master': { color: 'from-indigo-600 to-purple-600', icon: '🎓' }
}
